export default {
  KEY: {
    HOME: 'H',
    WOMAN: 'W',
    MAN: 'M',
    KIDS: 'B',
    UNISEX: 'X',
    COMMUNICATION_TOOLS: 'CMT',
    EXTRA: 'EXT',
  },
};



// WEBPACK FOOTER //
// ./src/app/shared/menu/menu.constant.js